import script from "./InsuranceClaimsPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceClaimsPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceClaimsPopUp.vue?vue&type=style&index=0&id=16047f12&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16047f12"]])

export default __exports__